import React from 'react';
import Icon from './icon';

export default ({
  items = [], outline = false, titleClassName, iconClassName, containerClassName, // name, icon, onClick, color, renderer
}) => (
  <span className="tiles flex-wrap">
    {items.map(({
      name, icon, onClick, color = 'var(--color-base)', renderer,
    }) => (renderer ? renderer()
      : outline ? (
        <span className={`tiles-item ${containerClassName}`} key={name} onClick={onClick} style={{ backgroundColor: color }}>
          <Icon name={icon} className={`icon ${iconClassName}`} />
          <span className={`f-14 w-100p text-center p-t-8 ${titleClassName}`}>{name}</span>
        </span>
      ) : (
        <span className={`tiles-item ${containerClassName}`} key={name} onClick={onClick} style={{ backgroundColor: color }}>
          <Icon name={icon} className={`icon ${iconClassName}`} />
          <span className={`f-14 w-100p text-center p-t-8 ${titleClassName}`}>{name}</span>
        </span>
      )
    ))}
  </span>
);
